module.exports = __webpack_public_path__ + "img/c15.65e8addd.png";